import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ constraint, nextConstraint }) =>
    present(
      repository
        .updateConstraint(constraint, nextConstraint)
        .then(({ impactedElements, ...constraint }) => ({
          constraint,
          impactedElements,
        }))
        .catch(() => Promise.reject({ constraint, nextConstraint })),
    );
}

export type { Interactor };

export { createInteractor };
